let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eobZl")).then(() => parcelRequire('ivxTJ'));